module.exports = __webpack_public_path__ + "img/2 (9).983d2649.jpg";